import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Pedido en mesa',
    [ORDER_METHODS.PICKUP]: 'Recogida',
    [ORDER_METHODS.DELIVERY]: 'Entrega a domicilio',
  },
};
